import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Customer } from '@models';
import { CustomerState } from '@state';
import { RouteState, selectRouteState } from '@state/route';

export const selectCustomerState =
  createFeatureSelector<CustomerState>('customer');

export const selectCustomers = createSelector(
  selectCustomerState,
  (state: CustomerState) => state.customers ?? []
);

export const selectCurrentCustomer = createSelector(
  selectCustomers,
  selectRouteState,
  (customers: Customer[], route: RouteState) => {
    return customers.find((x) => x.id == route.params['customerId']);
  }
);

export const selectCustomersFetchedAt = createSelector(
  selectCustomerState,
  (state: CustomerState) => state.fetchedAt
);
